export default {
    wait() {
        $('.cForm-Register .cForm-Register__Bottom [type=submit]').attr('disabled', true);
        $('.cForm-Register .form-group').removeClass('has-error');
        $('.cForm-Register__Error').html('');
    },

    done(data) {
        if (data.success) {
            // Apri la modale di registrazione completata
            window.openModal('registration_completed');
            $('.cForm-Register form').get(0).reset();

        } else if (typeof data.error !== 'undefined') {

            let field, line;
            const fieldPrefix = 'fos_user_registration_form';
            const errors = $('.cForm-Register__Error');
            const setFieldSelected = (fieldName) => {
                $(`.cForm-Register [name="${fieldName}"]`).closest('.form-group').addClass('has-error');
            };

            for (field in data.error) {
                if (data.error[field]) {
                    line = $('<li>').text(data.error[field]);
                    errors.append($('<ul>').append(line));
                    
                    if (field == 'plainPassword') {
                        setFieldSelected(`${fieldPrefix}[${field}][first]`);
                        setFieldSelected(`${fieldPrefix}[${field}][second]`);
                    } else {
                        setFieldSelected(`${fieldPrefix}[${field}]`);
                    }
                }
            }
        }
        
        $('.cForm-Register .cForm-Register__Bottom [type=submit]').attr('disabled', false);
    },

    fail() {
        $('.cForm-Register .cForm-Register__Bottom [type=submit]').attr('disabled', false);
    },
};



// WEBPACK FOOTER //
// ./assets/js/component/ajax/register.js